<template>
  <div id="project_view" v-if="item">
    <div class="centered">
        <div class="yazam_card">
            <div class="info">
                <div class="titles">
                    <div class="first_titles">
                        <p>להלן פרטי המכרז המלאים שמנהל עבורכם <strong>{{  item.user_name }}</strong> במערכת של המכרז השקוף.
לשאלות ופרטים נוספים בנוגע לסעיפים השונים, ניתן לפנות לעו"ד</p>
                        <!-- <div class="title" v-text="item.user_name"></div> -->
                        <!-- <div v-text="item.user_data.company_name"></div>
                        <div v-text="item.user_data.link_company_site"></div> -->
                    </div>
                    <!-- <div class="num_projects">
                        <div class="icon_wrap">
                            <div class="icon building_white_icon"></div>
                        </div>
                        <div> השתתף ב {{item.user_projects.length + item.user_projects_urban.length}} מכרזים</div>
                    </div> -->
                </div>
                <div class="contact">
                    <!-- <div class="detail">
                        <div class="icon_wrap">
                            <div class="icon location_icon"></div>
                        </div>
                        <div v-text="item.user_data.company_address"></div>
                    </div> -->
                    <div class="detail">
                        <div class="icon_wrap">
                            <div class="icon phone_icon"></div>
                        </div>
                        <div v-text="item.user_phone_company_contact" ></div>
                    </div>
                    <!-- <div class="detail">
                        <div class="icon_wrap">
                            <div class="icon contact_icon"></div>
                        </div>
                        <div v-text="item.user_data.phone_company_contact + ' | ' + item.user_data.phone_company_contact"></div>
                    </div> -->
                    <div class="detail">
                        <div class="icon_wrap">
                            <div class="icon email_icon"></div>
                        </div>
                        <div v-text="item.user_username"></div>
                    </div>
                </div>
            </div>
            <div class="yazam_img" :style="bg(item.user_pic_parsed)"></div>
        </div>

        <div class="status_section">
            <h2>סטטוס המכרז</h2>
            <div class="status_bar_container">
                <ul class="status_bar">
                    <li :class="{selected: +item.status_number === 1}">
                        <div class="icon_container"><div class="icon"></div></div>
                        <span class="text">בהכנה</span>
                    </li>
                    <li :class="{selected: +item.status_number === 2}">
                        <div class="icon_container"><div class="icon"></div></div>
                        <span class="text">קבלת הצעות</span>
                    </li>
                    <li :class="{selected: +item.status_number === 3}">
                        <div class="icon_container"><div class="icon"></div></div>
                        <span class="text">נסגר</span>
                    </li>
                    <li :class="{selected: +item.status_number === 4}">
                        <div class="icon_container"><div class="icon"></div></div>
                        <span class="text">שקלול הצעות</span>
                    </li>
                    <li :class="{selected: +item.status_number === 5}">
                        <div class="icon_container"><div class="icon"></div></div>
                        <span class="text">הסתיים</span>
                    </li>
                </ul>
            </div>
        </div>

        <div class="project_con">
            <existingDetails state="watch" :item="item" v-if="(currentStep === 1 || currentStep === 0)" />
            <ComparisonTable 
                v-if="showComparisonTable && entrepreneurs" 
                :selectedEnts="entrepreneurs"
                :showTrans="showTrans"
            />
            <ClauseComparison 
                v-if="contract"
                ref="clauseComparison"
                :selectedEnts="entrepreneurs"
                :contract="contract"
                :mode="'watch'"
            />
            
        </div>
    </div>
  </div>
</template>

<script>
import existingDetails from '../components/applyingPrj/existingDetails'
import ComparisonTable from '../components/offersDetails/ComparisonTable.vue'
import ClauseComparison from '../components/offersDetails/ClauseComparison.vue'

export default {
    components: {existingDetails, ComparisonTable, ClauseComparison},
    data() {
        return {
            item: null,
            currentStep: 1,
            token: this.$route.params?.token,
            showComparisonTable: true,
            entrepreneurs: [],
            contract: [],
            selectedEntrepreneursIds: [],
            showTrans: true,
            previousStep: 1
        }
    },
    computed: {
        selectedEnts() {
            const selectedItems = this.entrepreneurs.filter(item => this.selectedEntrepreneursIds.includes(item.id));
            return selectedItems.length > 0 ? selectedItems : null;
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            try {
                const [{ data: project }, { data: { contract, users } }] = await Promise.all([
                    this.api({ action: 'projects/get', data: { token: this.token }}),
                    this.api({ action: 'projects/get_applying_project_users', data: { token: this.token }})
                ]);

                this.item = project;
                this.contract = contract;
                this.entrepreneurs = users;
            } catch (error) {
                console.error('Error initializing project:', error);
            }
        },
        toggleComparisonTable() {
            if (!this.showComparisonTable) {
                this.previousStep = this.currentStep;
                this.showComparisonTable = true;
                
                this.showTrans = false;
                setTimeout(() => {
                    this.showTrans = true;
                }, 100);
            } else {
                this.currentStep = this.previousStep;
                this.showComparisonTable = false;
            }
        },
        handleTableScroll(scrollLeft) {
            // Handle scroll event from ComparisonTable component
            if (this.$refs.clauseComparison) {
                this.$refs.clauseComparison.handleTableScroll(scrollLeft);
            }
        },
        bg(pic) {
            return pic ? `background-image: url(${pic})` : '';
        }
    }
}
</script>

<style lang="scss">
#project_view { padding-bottom: 100px;
    .centered {display: flex; flex-direction: column; gap: var(--gap_xbig);}
    .yazam_card { min-height: 200px;
        .info { justify-content: space-between;}
    }
    .status_section { display: flex; flex-direction: column; gap: var(--gap_small);
        h2 {}
        .status_bar_container { background: var(--Surface-card-secondary, #F5F9FA); padding: 40px 0px; background: var(--gray); border-radius: var(--radius); }
    }
    .project_con { display: flex; flex-direction: column; gap: var(--gap_mid);
        .title_filters {display: flex; flex-direction: column; gap: var(--gap);
            h2 {}
            .actions { display: flex; justify-content: space-between; gap: var(--gap);
                .btn { background: var(--gray); padding: 10px 20px; border-radius: var(--radius); cursor: pointer; 
                    &.active { 
                        background: var(--dark_blue); 
                        color: white; 
                    }
                }
            }
        }
    }
}
</style>